import React, { useCallback, useContext, useEffect, useState } from 'react'
import DashboardVisual from './DashboardVisual';
import { MainContext } from 'context/mainContext';
import moment from "moment";
import { generateUUID } from 'services/EVAResponseService';
import CustomSpinner from 'components/Misc/CustomSpinner';
var momentTZ = require("moment-timezone");

function DataAnalyzerComponentItem({ item, index, selectedDashboardTemplate, isExporting, isEVAAnalyseDashboard }) {
    const { bgColor, textColor, userDetails, selectedClientID, firmDetails } = useContext(MainContext);
    const [evaAnswer, setEVAAnswer] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const [selectedItem, setSelectedItem] = useState(item);
    const [query, setQuery] = useState(null)

    useEffect(() => {
        const processData = async () => {
            if(item.visual_type === "Card") {
   
                const dashboardItem = selectedDashboardTemplate?.dashboardTemplate
                if(dashboardItem) {
    
                    const selectedDashboardItem = dashboardItem.find(i => i.my_row_id === item.my_row_id)

                    selectedDashboardItem.visualData = item.visualData || {};
                    selectedDashboardItem.visualData = item.visualData
                    selectedDashboardItem.visualData.templateItemVisual = selectedDashboardItem.visual
                    selectedDashboardItem.integrationImage = item.integrationImage
                    selectedDashboardItem.lastRefreshData = item.lastRefreshData

                    setSelectedItem(selectedDashboardItem)
                }
            } else {
                setSelectedItem(item)
            }

            if(!isEVAAnalyseDashboard)
                await processEVAIntro(userDetails.User, selectedClientID, firmDetails.AccountingFirmID, selectedItem)
        }

        processData()
    }, [item])



    const processEVAIntro = useCallback(async (user, ClientId, businessId, selectedItem) => {
        const query = `analyser, query: '', data: ${JSON.stringify([{ header: item.visual_type === "Card" ? selectedItem.cleanedHeader : selectedItem.header, body: selectedItem.sqlresult}])}`;
        const uuid = await generateUUID()
        const raw = {
            "chatId": uuid,
            "query": query,
            "UserInfo": {
                "chatId": uuid,
                "UserId": user.UserID,
                "Name": `${user.FirstName} ${user.LastName}`,
                "ClientId": ClientId,
                "BusinessId": businessId
            }
        };
        try {
            setIsLoading(true)
            const response = await fetch('https://evabetaprod.azurewebsites.net/eva_stream', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(raw)
            });
            
            const reader = response.body.getReader();
            let chunks = '';
            const streamMessageArray = []
        
            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                chunks += new TextDecoder().decode(value);
                const messagesArray = chunks.split('\n');
                streamMessageArray.push(chunks)
                // setStreamMessage([...streamMessageArray])
            }
        
            const msg = streamMessageArray[streamMessageArray.length - 1]
        
            const EVAResponse = {
                "user": {
                    "_id": "1",
                    "sender": "1",
                    "name": "EVA"
                },
                "_id": "",
                "uuid": "",
                "clientid": "6780e66b-26c5-4a2f-b622-a7ab85de0eb1",
                "userid": "85cf8335-36e3-48d8-bd00-e5cbd4e6c266",
                "query": "",
                "text": get_answer(msg),
                "sender": "1",
                "__v": 0,
                formatedResponse: {
                "answer": get_answer(msg),
                "observation": "",
                "parsedData": [],
                "integration": "",
                "headers": [],
                "treeViewData": [],
                "isWithChild": false,
                "version": "1.1.2411.07064",
                "stext": "",
                "groupLevel": 1,
                "newTreeData": [],
                "newTreeDataWithGrandTotal": []
                }
            }

            setEVAAnswer(EVAResponse.formatedResponse.answer)
            setQuery(EVAResponse.query)

            function get_answer(validJsonString) {
                try {
                    const updatedString = validJsonString.replace(/\\n/g, "`nl` ")
                    const res = JSON.parse(updatedString)
                    return res.answer
                } catch {
                    let startIdx = validJsonString.indexOf('"answer":');
                    if(startIdx < 0) startIdx = validJsonString.indexOf(`"answer":`); 
        
                    let endIdx = validJsonString.indexOf('"observation":');
                    let answer = validJsonString.substring(startIdx + ( validJsonString.indexOf(`"answer":`) !== -1 ? 11 : 14), endIdx - 11)
        
                    answer = textParcer(answer)
                    return answer.replace(/\\",/g, '.').replace(/\."/g, '.').replace(/\"/g, "'").replace(/',/g, "").replace("u2019","'");
                }
            }
            function textParcer(item) {
                return item
                .replace(/\\",/g, '')
                .replace(/\\t/g, "")
                .replace('"\n', "\n")
                .replace(/\\n/g, "`nl` ")
                // .replace(/\(/g, '[')
                // .replace(/\)/g, ']')
                .replace("   ", "")
                .replace(/\\'/g, '"')
                .replace(/\\"/g, '')
                .replace(/'/g, '"')
                .replace(/\\/g, '')
                .replace(/\\/g, '')
                .replace(/\: None/g, ': "None"')
                .replace(/\: Null/g, ': "None"')
                // .replace(/Decimal\(/g, '')
                .replace(/\),/g, ',')
                .replace(/\)}/g, '}');
            }
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }

    }, [])

    const FormattedAnswer = ({answer}) => {
        if (typeof answer !== 'string') {
            console.warn('FormattedAnswer expected a string but received:', answer);
            return '';
        }
    
        const htmlString = answer
            // .replace(/`nl`/g, '\n')
            .replace(/^# (.*?)`nl` `nl`/g, '<h1>$1</h1>')
            .replace(/### (.*?)(`nl`|\n|:)/g, '<h2>$1</h2>')
            .replace(/## (.*?)(`nl`|\n|:)/g, '<div class="noteHeader">📈 $1</div>')
            // .replace(/## (.*?):/g, '<div class="noteHeader">📈 $1</div>')
            .replace(/`nl`/g, '<div></div>')
            .replace(/## Key Insights:/g, '<div class="noteHeader">💡 Key Insights</div>')
            .replace(/ ## Recommendation:/g, '<div class="noteHeader">📌 Recommendations</div>')
            .replace(/^### (.*)$/gm, '<h3>$1</h3>')
            .replace(/^## (.*)$/gm, '<h2>$1</h2>')
            .replace(/^# (.*)$/g, '<h1>$1</h1>')
            // .replace(/^- (.*)$/gm, '<li>$1</li>')
            .replace(/(<li>.*?<\/li>)/gms, '<ul>$1</ul>')
            .replace(/- \*\*(.*?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

        return (
            <div dangerouslySetInnerHTML={{ __html: htmlString }} />
        );
    };
    function dateFormat(dateToFormat) {
        const date = new Date(dateToFormat);
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        };

        const formatted = date.toLocaleString('en-US', options);
        return  formatted
    }
    return (
        <div className='EVAanalysisContainer' key={index}>
            <div className='EVAanalysisHeader' style={{ marginBottom: isEVAAnalyseDashboard && 15 }}>
                <img src={selectedItem?.integrationImage} alt="Integration Logo" style={{
                                                                                        ...(isEVAAnalyseDashboard && {
                                                                                        width: 50,
                                                                                        height: 50,
                                                                                        padding: 5
                                                                                     })}} /> 
                <div className='EVAAnalysisIntegration'>
                    <span className='reportHeader' style={{ fontSize: isEVAAnalyseDashboard && 15 }}>    
                        {selectedItem?.name} Report
                    </span>
                    <span style={{ fontSize: isEVAAnalyseDashboard && 11 }}>
                        Last Refresh:{" "}
                        {selectedItem?.lastRefreshData?.lastRefresh
                        ? dateFormat(selectedItem?.lastRefreshData?.lastRefresh)
                        : "No record found"}
                    </span>
                    <span style={{ fontSize: isEVAAnalyseDashboard && 11 }}>
                        {`Generated on: ${new Date().toLocaleDateString()}`}
                    </span>
                </div>
            </div>
            {isLoading ? 
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <CustomSpinner /> 
                </div>
            :
            <>
                {evaAnswer ? 
                    <div className='EVAAnalyserResponseContainer'>
                        <FormattedAnswer
                            answer={evaAnswer} 
                        />
                    </div>
                :
                    <>
                    </>    
                }
                {selectedItem &&
                    <DashboardVisual
                        item={selectedItem}
                        index={0}
                        selectedDashboardTemplate={selectedDashboardTemplate}
                        gridHeader={selectedItem?.visualData?.gridHeader || selectedItem?.cleanedHeader}
                        gridOriginalHeader={selectedItem?.visualData?.gridOriginalHeader}
                        sqlresult={selectedItem?.visualData?.sqlresult}
                        theme={selectedItem?.visualData?.theme}
                        treeViewData={selectedItem?.visualData?.treeViewData}
                        isWithChild={selectedItem?.visualData?.isWithChild}
                        isShowGrid={selectedItem?.visualData?.isShowGrid}
                        toggleAll={true}
                        isShowGrap={selectedItem?.visualData?.isShowGrap}
                        toggleFullScreen={selectedItem?.visualData?.toggleFullScreen}
                        handleSetItemIndexToEdit={selectedItem?.visualData?.handleSetItemIndexToEdit}
                        handleItemNewUpdate={selectedItem?.visualData?.handleItemNewUpdate}
                        templateItemVisual={selectedItem?.visual}
                        layouts={selectedItem?.visualData?.layouts}
                        onEditName={selectedItem?.visualData?.onEditName}
                        newDashboardItemName={selectedItem?.visualData?.newDashboardItemName}
                        tempLayout={selectedItem?.visualData?.tempLayout}
                        groupLevel={selectedItem?.visualData?.groupLevel}
                        handleNewUpdate={selectedItem?.visualData?.handleNewUpdate}
                        pdfVisual={true}
                        isExporting={isExporting}
                    />
                }
                
            </>}
            {/* <div className='EVAanalysisFooter' style={{ background: bgColor , color: textColor }}>
                <span className='reportFooter'>    
                    End of {selectedItem.name} Report
                </span>
                <span>
                    {`Generated on: ${new Date().toLocaleDateString()}`}
                </span>
            </div> */}
        </div>
    )
}

export default DataAnalyzerComponentItem